import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'app-link-button',
    templateUrl: './link-button.component.html',
    styleUrls: ['./link-button.component.scss'],
    imports: [FontAwesomeModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkButtonComponent implements OnChanges {



  @Input() href: string = ""
  @Input() target: string = "_self"
  @Input() icon: IconDefinition | undefined
  @Input() severity: "secondary" | "success" | "info" | "warning" | "help" | "danger" | "outlined" | "" = ""
  @Input() size: "standard" | "small" | "large" = "standard"
  @Input() iconPadding = true;


  private _class = "p-element p-button p-component"

  set class(value: string) {
    this._class = value
    this.chRef.markForCheck()
  }

  get class(): string {
    return this._class
  }

  constructor(
    private chRef: ChangeDetectorRef
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.class = this.buildClass()
  }

  buildClass() {
    let returnClass = "p-element p-button p-component"

    if (this.severity !== "") {
      returnClass += " p-button-" + this.severity
    }

    if (this.size !== "standard") {
      switch (this.size) {
        case "small":
          returnClass += " p-button-sm"
          break
        case "large":
          returnClass += " p-button-lg"
      }
    }

    return returnClass
  }

}
